module.exports = __webpack_public_path__ + "img/attract_project_model.1654f1b9.png";